import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  stage_id: "",
  data: {
    checklist_data: [],
  },
};

const checklistData_slice = createSlice({
  name: "checklistData",
  initialState,
  reducers: {
    set_stage_id: (state, action) => {
      state.id = action.payload;
    },
    set_checklist_data: (state, action) => {
      state.data.checklist_data = action.payload;
    },
    set_current_checklist_data: (state, action) => {
      return action.payload;
    },
    reset_checklist_data: () => initialState,
  },
});

export const {
  set_stage_id,
  set_checklist_data,
  set_current_checklist_data,
  reset_checklist_data,
} = checklistData_slice.actions;

export default checklistData_slice.reducer;
